"use client";

import * as React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function HvorforNwConsult() {
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224475" id="brži-rast-poslovanja" className="bg-background py-24 md:py-32 lg:py-40 overflow-hidden">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          
          {}
          <div ref={leftRef} className={cn("lg:col-span-7 transition-all duration-1000 ease-out", isLeftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl xl:text-7xl leading-[1.2] text-foreground tracking-tighter font-bold">
              Pridobijte nove klijente lakše i <span className="text-primary">rastite brže</span> uz Mobileo.
            </h2>
          </div>

          {}
          <div ref={rightRef} className={cn("lg:col-span-5 lg:pt-4 transition-all duration-1000 delay-200 ease-out", isRightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
            <div className="flex flex-col gap-6">
              <div className="h-px w-12 bg-secondary mb-2" aria-hidden="true" />
              <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-default">Koristite Mobileo softver kao učinkovit prodajni alat za pridobivanje klijenata pokazujući im dodanu vrijednost vaših usluga u stvarnom vremenu.</p>
              <p className="text-base text-muted-foreground font-default">Omogućite svojim klijentima pristup korisničkom portalu za praćenje aktivnosti djelatnika u stvarnom vremenu te im pružite jasan uvid u kvalitetu i profesionalnost usluge koju vaša tvrtka svakodnevno pruža.</p>
            </div>
          </div>

        </div>
      </div>
    </section>;
}